import React from 'react';

interface RocketLaunchIconProps {
  width?: number;
  height?: number;
  className?: string;
  color?: string;
}

export const RocketLaunchIcon: React.FC<RocketLaunchIconProps> = ({
  width = 24,
  height = 24,
  className,
  color = "#FFDD00"
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      className={className}
      style={{ display: 'inline-block' }}
    >
      <path 
        fill={color} 
        d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 1L13 3V11.5L11 13.5L7.5 10L9.5 8H1V10L7 16L10 13H14.5L16.5 15V7L21 9ZM12.5 7.5C12.5 8.33 11.83 9 11 9S9.5 8.33 9.5 7.5S10.17 6 11 6S12.5 6.67 12.5 7.5Z"
      />
      <path 
        fill={color} 
        d="M22 12C22 12.6 21.6 13 21 13H19V15C19 15.6 18.6 16 18 16S17 15.6 17 15V13H15C14.4 13 14 12.6 14 12S14.4 11 15 11H17V9C17 8.4 17.4 8 18 8S19 8.4 19 9V11H21C21.6 11 22 11.4 22 12Z"
        opacity="0.7"
      />
      <circle 
        cx="6" 
        cy="18" 
        r="2" 
        fill={color}
        opacity="0.8"
      />
      <circle 
        cx="2" 
        cy="22" 
        r="1" 
        fill={color}
        opacity="0.6"
      />
    </svg>
  );
};
